module.exports = __webpack_public_path__ + "img/Single_Multi_Recall.0682c2fd.png";